var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"open",on:{"click":_vm.clickOpenHandler}},[_vm._v("打开APP")])])}
var staticRenderFns = []

export { render, staticRenderFns }